import type { PropsWithChildren } from "react";

import { translate } from "app/filters/i18nFilter";
import { isTimeoutError } from "app/pages/sales-intelligence/query/utils";

import { StyledSearchErrorState } from "./styles";

type TimeoutErrorGateProps = PropsWithChildren<{
    isError: boolean;
    error: unknown;
}>;

const TimeoutErrorGate = ({ isError, error, children }: TimeoutErrorGateProps) => {
    if (isError && isTimeoutError(error)) {
        return (
            <StyledSearchErrorState
                title={translate("si.common.error.timeout.title")}
                subtitle={translate("si.common.error.timeout.subtitle")}
                iconName="no-data-tree"
            />
        );
    }

    return children;
};

export default TimeoutErrorGate;
